const BoilerPlate = {
    mainSplit: null,
    mainSplitShift: null,
    mainSectionFixed: null,
    mainSectionFixedShift: null,
    landing: null,
    init: () => {
        //two column
        BoilerPlate.mainSplit = document.querySelector("#main-split");
        BoilerPlate.mainSplitShift = document.querySelector("#main-split-shift");

        //fixed content
        BoilerPlate.mainSectionFixed = document.querySelector("#main-section-fixed");
        BoilerPlate.mainSectionFixedShift = document.querySelector("#main-section-fixed-shift");

        //landing
        BoilerPlate.landing = document.querySelector("#landing");

        BoilerPlate.bind();
    },
    bind: () => {
        //two column
        if (BoilerPlate.mainSplitShift) {
            BoilerPlate.mainSplitShift.addEventListener("click", (e) => {
                if (!BoilerPlate.mainSplit.classList.contains("active")) {
                    BoilerPlate.mainSplit.classList.add("active");
                } else {
                    BoilerPlate.mainSplit.classList.remove("active");
                }
            });
        }
        //fixed content
        if (BoilerPlate.mainSectionFixed) {
            BoilerPlate.mainSectionFixedShift.addEventListener("click", (e) => {
                if (!BoilerPlate.mainSectionFixed.classList.contains("active")) {
                    BoilerPlate.mainSectionFixed.classList.add("active");
                } else {
                    BoilerPlate.mainSectionFixed.classList.remove("active");
                }
            });
        }
    }
}

export default BoilerPlate;